import { JsonTableStyles } from './styles';
import React from 'react';

const ReactJsonTable = require('ts-react-json-table');

type JsonTableProps = {
  data: any;
};

export default function JsonTable({ data }: JsonTableProps): JSX.Element {
  return (
    <JsonTableStyles>
      <ReactJsonTable rows={data} />
    </JsonTableStyles>
  );
}
